// extracted by mini-css-extract-plugin
export default {"MyBtn":"MyBtnUnactive_MyBtn__taCL9","active":"MyBtnUnactive_active__CifEJ","padding":"MyBtnUnactive_padding__vPGLL","rus":"MyBtnUnactive_rus__DPwlf"};